import React from 'react';
import CompanyForm from './CompanyForm';

const AddCompany: React.FC = () => {
  return <CompanyForm isEditMode={false} />;
};

export default AddCompany;